<template>
  <div class="coupon-item">
    <div class="coupon-item-left">
      <div class="coupon-item__amount">
        <span>¥</span>200
      </div>
    </div>
    <div class="coupon-item-right">
      <div class="coupon-item__name">优惠券</div>
      <p>2029-08-01到期</p>
    </div>
    <div class="coupon-item-btn">立即使用</div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {},

  async created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.coupon-item {
  position: relative;
  margin: 17px 0;
  // width: 343px;
  height: 90px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;

  .coupon-item-left {
    width: 115px;
    height: 100%;
    // background: linear-gradient(
    //   45deg,
    //   rgba(243, 69, 31, 1) 0%,
    //   rgba(255, 126, 53, 1) 100%
    // );
    background-image: url(~@/icons/ad/ad-coupon-bg_active.png);
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;

    .coupon-item__amount {
      height: 56px;
      font-size: 46px;
      font-weight: bold;
      color: #ffffff;
      // line-height: 56px;
      line-height: 90px;

      span {
        font-size: 20px;
      }
    }
  }

  .coupon-item-right {
    flex: 1;
    padding-top: 23px;
    padding-left: 22px;

    .coupon-item__name {
      height: 21px;
      font-size: 15px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 21px;
    }

    p {
      margin: 6px 0 0;
      padding: 0;
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 17px;
    }
  }

  .coupon-item-btn {
    position: absolute;
    top: 32px;
    right: 15px;
    width: 70px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid rgba(244, 93, 58, 1);
    text-align: center;
    font-size: 11px;
    font-weight: 500;
    color: rgba(243, 70, 31, 1);
    line-height: 22px;
    box-sizing: border-box;
  }
}
</style>
